import type { CmxDocumentContentSlotEntry } from './cmxDocumentContentSlot';

/**
 * `documentDescription` off the first matched rendition, then its `noteType`, else positional
 * `Note #N` (1-based) within the cmx-document-content entries specifically -- legacy notes have their own label and are numbered
 * separately, per the outcome this slot was built for. Shared between `NoteNav` (the tab) and
 * `SourceDocumentModal` (the modal header) so the two never drift.
 */
export function cmxDocumentContentLabel(
  entry: CmxDocumentContentSlotEntry,
  index: number
): string {
  const rendition = entry.renditions?.[0];
  return (
    rendition?.documentDescription || rendition?.noteType || `Note #${index + 1}`
  );
}
